import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import clsx from "clsx";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useStaticContext from "@hooks/useStaticContext";
import useStores from "@hooks/useStores";

import ZipcodeTextField from "@components/Global/Custom/TextField/types/ZipcodeTextField";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import LogoIcon from "@components/Global/Custom/Logo/LogoIcon";

const { SITE_NAME } = process.env;

const ContentPromo = ({
	header,
	subHeader,
	button,
	right,
	icon,
	hideZip,
	href,
}) => {
	const classes = useStyles("Content");
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
	const { contentStore: store } = useStores();

	const { app } = useStaticContext();

	const { zipcode } = app.location || {};

	return (
		<div className={classes.promoBox}>
			{icon && (
				<Box mb={4}>
					<LogoIcon width={40} height={"auto"} />
				</Box>
			)}
			<div className={classes.promoBoxHeader}>{header}</div>
			<div className={classes.promoBoxSubHeader}>{subHeader}</div>
			<div
				className={clsx({
					[classes.promoBoxFlexRight]: right,
					[classes.promoBoxFlex]: !right,
				})}
			>
				{!hideZip && (
					<ZipcodeTextField
						fullWidth={isMobile || right}
						variant={"outlined"}
						id={"zip"}
						name="zip"
						defaultValue={zipcode}
						InputProps={{
							style: {
								fontWeight: 600,
								backgroundColor: "#FFF",
							},
						}}
					/>
				)}
				<div
					className={clsx({
						[classes.promoBoxButtonWrapRight]: right,
						[classes.promoBoxButtonWrap]: !right,
					})}
				>
					<Button
						fullWidth={isMobile || right}
						variant={"contained"}
						disableElevation
						color={"primary"}
						size={"large"}
						href={
							href
								? href +
								  "?utm_source=content&utm_medium=promo-right&utm_content=content&utm_campaign=promo-right"
								: SITE_NAME === "trustedcare"
								? "/"
								: store.service?.url +
								  "?utm_source=content&utm_medium=promo-right&utm_content=content&utm_campaign=promo-right"
						}
						target="_blank"
						className={classes.promoBoxButton}
					>
						{button ? button : "Search"}
					</Button>
				</div>
			</div>
		</div>
	);
};

ContentPromo.propTypes = {};
export default ContentPromo;
